import { t } from '@web/i18n';
import { Button, Dialog, DialogContent, DialogTitle, Textarea } from '@web/ui/core/atoms';

/**
 * Confirmation dialog for concluding (closing as resolved) a card. Presentational —
 * dialog state, the optional reason and the mutation live in `useCloseCard`.
 * Mirrors `ClaimConfirmDialog` + an optional reason textarea.
 */
export function CloseConfirmDialog({
  open,
  pending,
  reason,
  onReasonChange,
  onConfirm,
  onCancel,
}: Readonly<{
  open: boolean;
  pending: boolean;
  reason: string;
  onReasonChange: (value: string) => void;
  onConfirm: () => void;
  onCancel: () => void;
}>): React.JSX.Element | null {
  if (!open) return null;
  return (
    <Dialog
      open
      onOpenChange={(o) => {
        if (!o) onCancel();
      }}
    >
      <DialogContent>
        <DialogTitle className="text-base font-medium text-foreground">
          {t('card.close.dialog.title')}
        </DialogTitle>
        <p className="text-meta text-muted-foreground">{t('card.close.dialog.body')}</p>
        <Textarea
          aria-label={t('card.close.dialog.reasonLabel')}
          placeholder={t('card.close.dialog.reasonPlaceholder')}
          value={reason}
          maxLength={2000}
          onChange={(e) => {
            onReasonChange(e.target.value);
          }}
        />
        <div className="flex justify-end gap-2">
          <Button variant="ghost" size="sm" onClick={onCancel}>
            {t('card.close.dialog.cancel')}
          </Button>
          <Button variant="primary" size="sm" disabled={pending} onClick={onConfirm}>
            {t('card.close.dialog.confirm')}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
